import React, { useMemo, useState } from "react";
import Table from "../../table";
import styles from "./CPTCodesTable.module.css";
import Skeleton from "../Skeleton";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "../../ui/select";
import Modal from "../../shared-modules/Modal";
import { Eye } from "lucide-react";

const CPTCodesTable = ({
  data = [],
  title = "CPT Codes Generated",
  isLoading = false,
  categoryFilter = "",
  onCategoryChange = () => {},
}) => {
  const [isDescriptionOpen, setIsDescriptionOpen] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState("");

  const formatCurrency = (value) =>
  isNaN(Number(value)) || value === "" ? "-" : `$${Number(value)}`;

  const tableData = useMemo(() => data, [data]);

  const columns = useMemo(
    () => [
      { key: "cpt_code", label: "CPT Code", sorting: true, alignLeft: true },
    
      { key: "count", label: "Billed Count", sorting: true, alignLeft: true },
      { key: "category", label: "Category", sorting: true, alignLeft: true },
      {
        key: "billed_revenue",
        label: "Billed Revenue",
        sorting: true,
        alignLeft: true,
        render: (row) => formatCurrency(row.billed_revenue),
      },
        {
        key: "description",
        label: "Description",
        sorting: false,
        // alignLeft: true,
        render: (row) => (
          <button
            type="button"
            className={styles.descriptionButton}
            onClick={() => {
              setSelectedDescription(row.description || "No description available.");
              setIsDescriptionOpen(true);
            }}
            aria-label="View description"
          >
            <Eye size={16} />
          </button>
        ),
      },
    ],
    []
  );

  return (
    <div className={styles.tableContainer}>
      <div className={styles.tableHeader}>
        {title && <h3 className={styles.tableTitle}>{title}</h3>}
        <div className={styles.filterGroup}>
          <label className={styles.filterLabel} htmlFor="cpt-category-filter">
           Filter By Category :
          </label>
          <Select
            value={categoryFilter}
            onChange={(value) => onCategoryChange(value)}
            placeholder="All"
            className={styles.filterSelectWrapper}
          >
            <SelectTrigger className={styles.filterSelectTrigger}>
              <SelectValue placeholder="All" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="">All</SelectItem>
              <SelectItem value="RPM">RPM</SelectItem>
              <SelectItem value="CCM">CCM</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
      {isLoading ? (
        <div className={styles.tableSkeleton}>
          {Array.from({ length: 8 }).map((_, index) => (
            <div key={`cpt-skel-${index}`} className={styles.skeletonRow}>
              <Skeleton width="15%" height="10px" radius="4px" />
              <Skeleton width="45%" height="10px" radius="4px" />
              <Skeleton width="10%" height="10px" radius="4px" />
              <Skeleton width="15%" height="10px" radius="4px" />
            </div>
          ))}
        </div>
      ) : (
        <Table data={tableData} columns={columns} height={230} />
      )}
      <Modal
        title="Description"
        isOpen={isDescriptionOpen}
        onClose={() => setIsDescriptionOpen(false)}
        width="480px"
        height="auto"
      >
        <div className={styles.descriptionModalBody}>{selectedDescription}</div>
      </Modal>
    </div>
  );
};

export default CPTCodesTable;
